"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Billboard = require("./Billboard.style");

var _AddToCalendar = require("../AddToCalendar");

var _ComponentWrapper = _interopRequireDefault(require("../ComponentWrapper"));

var _MarkdownRenderer = _interopRequireDefault(require("../MarkdownRenderer"));

var _DefaultButton = require("../Button/DefaultButton");

var Billboard = function Billboard(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      button = _ref.button,
      secondaryButton = _ref.secondaryButton,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["title", "subtitle", "button", "secondaryButton", "variant"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      billboard = _ref2.billboard;

  return /*#__PURE__*/_react.default.createElement(_Billboard.Wrapper, {
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, Object.assign({
    columnWidth: billboard.columnWidth
  }, rest), /*#__PURE__*/_react.default.createElement(_Billboard.BillboardColumn, null, /*#__PURE__*/_react.default.createElement(_Billboard.Content, {
    width: "100%",
    textAlign: button === null ? 'center' : 'left'
  }, title && /*#__PURE__*/_react.default.createElement(_Billboard.BillboardPageTitle, {
    size: "small",
    variant: variant
  }, title), subtitle && /*#__PURE__*/_react.default.createElement(_Billboard.Subtitle, {
    as: "div",
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
    copySize: billboard.subtitleFontSize,
    html: subtitle
  }))), /*#__PURE__*/_react.default.createElement(_Billboard.CtasWrap, null, button && /*#__PURE__*/_react.default.createElement(_Billboard.StyledButton, Object.assign({
    startIcon: button.icon,
    variant: billboard.btnVariant
  }, button), button.label), secondaryButton && /*#__PURE__*/_react.default.createElement(_Billboard.StyledButton, Object.assign({
    startIcon: secondaryButton.icon,
    variant: billboard.secondaryBtnVariant
  }, secondaryButton, {
    secondaryButton: secondaryButton
  }), secondaryButton.label)))));
};

Billboard.propTypes = {
  variant: _propTypes.default.oneOf(['primary', 'secondary']),
  title: _propTypes.default.string,
  subtitle: _propTypes.default.string,
  button: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    icon: _propTypes.default.string,
    calendarEvent: _propTypes.default.shape(_AddToCalendar.addToCalendarPropTypes),
    variant: _propTypes.default.oneOf(Object.values(_DefaultButton.ButtonType))
  }),
  secondaryButton: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    icon: _propTypes.default.string,
    calendarEvent: _propTypes.default.shape(_AddToCalendar.addToCalendarPropTypes),
    variant: _propTypes.default.oneOf(Object.values(_DefaultButton.ButtonType))
  })
};
Billboard.defaultProps = {
  title: null,
  variant: 'primary',
  subtitle: '',
  button: null,
  secondaryButton: null
};
var _default = Billboard;
exports.default = _default;